import { useContext, useEffect, useRef, useState } from "react";
import dynamic from "next/dynamic";
const Swiper = dynamic(() => import('swiper/react').then(mod => mod.Swiper), { ssr: false });
import { SwiperSlide } from 'swiper/react';
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

import styles from "./specialSlider.module.scss";
import Button from "@/components/Button";
import Link from "next/link";
import ArrowRight from "/packages/icons/arrow-right.svg";
import ArrowLeft from "/packages/icons/arrow-left.svg";
import Deals from '/packages/icons/category/deals.svg';
import SkeletonSpecialCard from "@/components/skeletons/SkeletonSpecialCard";
import SpecialItem from "@/components/specials/Special";

import StoreContext from "@/context/store";
import { useSpecials } from "@/context/specials";

export default function SpecialSlider({ title = "Specials", viewAllLink = "/specials" }) {
  const { store } = useContext(StoreContext);
  const { specials, fetchAllSpecials } = useSpecials();
  const [loading, setLoading] = useState(true);
  const swiperRef = useRef(null);

  const limitedArray = [...specials]
  .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
  .slice(0, 8);

  useEffect(() => {
    if (store) {
      fetchAllSpecials(store);
    }
  }, [store, fetchAllSpecials]);

  useEffect(() => {
    if (specials?.length > 0) {
      setLoading(false);
    }
  }, [specials]);

  return (
    <div className={styles.swiperWrapper}>
      <div className={styles.header}>
        <div className={styles.title}>

          <div className={styles.icon}>
            <Deals />
          </div>

          <h2>{title}</h2>
        </div>
        <Button
          type="link"
          href={viewAllLink}
          className="sliderLink"
          prefetch={false}
          ariaLabel="View All Deals"
        >
          <div>view all</div>
        </Button>
      </div>

      <Swiper
        modules={[Navigation]}
        className={styles.specialsSwiper}
        breakpoints={{
          1024: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 16 },
          768: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 14 },
          460: { slidesPerView: 1.5, slidesPerGroup: 1, spaceBetween: 10 },
          0: { slidesPerView: 1.2, slidesPerGroup: 1, spaceBetween: 10 },
        }}
        touchEventsTarget="container"
        navigation={{
          prevEl: `#specials-prev`,
          nextEl: `#specials-next`,
          clickable: true,
        }}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
      >
        <div className={styles.prev} id="specials-prev">
          <Button type="button" className="slider-arrow" ariaLabel="Previous Slide">
            <ArrowLeft />
          </Button>
        </div>
        <div className={styles.next} id="specials-next">
          <Button type="button" className="slider-arrow" ariaLabel="Next Slide">
            <ArrowRight />
          </Button>
        </div>

        {loading ? (
          [...Array(3)].map((_, index) => (
            <SwiperSlide key={index} className={`${styles.slide} bundle-card`}>
              <SkeletonSpecialCard type="special" />
            </SwiperSlide>
          ))
        ) : (
          <>
            {limitedArray.map((item, index) => (
              <SwiperSlide key={index} className={`${styles.slide} bundle-card`}>
                <SpecialItem item={item} />
              </SwiperSlide>
            ))}
            <SwiperSlide className={`${styles.lastSlide}`}>
              <Link href={viewAllLink}>
                <Deals />
                View All
              </Link>
            </SwiperSlide>
          </>
        )}
      </Swiper>
    </div>
  );
}
